export type IResetFormGroupStatus = (element: IjQueryElmOrHtmlElm) => void;

export function resetFormGroupStatus(element: IjQueryElmOrHtmlElm): void {
  const $formGroup = $(element).closest('.form-group');
  const $errorBlock = $formGroup.find('.error-block');
  $formGroup.removeClass('has-warning has-error has-error');
  $errorBlock
    .addClass('hide')
    .attr('aria-hidden', 'true')
    .text('');
}
